import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import './globalSearch.scss'
import { useTranslations } from 'next-intl'

const GlobalSearchLoading = () => {
  const t = useTranslations('globalSearch')
  return (
    <div className='global-search min-h-[500px]' id='globalSearch'>
         <div className='tabs-container'>
        <Skeleton
          width={76}
          height={29}
          className={`tab`}
        />
        <Skeleton
        width={108}
        height={29}
          className={`tab`}
        />
      </div>
      <form>
        <div className='fields-container'>
          <div className='field'>
            <Skeleton height={14} width={100} />
            <Skeleton height={50} />
          </div>

          <div className='field'>
            <Skeleton height={14} width={100} />
            <Skeleton height={50} />
          </div>

          <div className='field'>
            <Skeleton height={14} width={100} />
            <Skeleton height={50} />
          </div>

          <div className='field'>
            <Skeleton height={14} width={100} />
            <Skeleton height={50} />
          </div>

          <div className='field rounded-full overflow-hidden w-full'>
            <Skeleton height={38.5} className='rounded-full' />
          </div>
        </div>
      </form>
    </div>
  )
}

export default GlobalSearchLoading
